import { styled } from 'styled-components';
import { motion } from 'framer-motion';

export const CarouselWrapper = styled(motion.div)`
  display: flex;
  flex-direction: column;
  gap: ${props => props.theme.spaceMd};
`;

export const ImageWrapper = styled.div`
  --image-height: 32rem;
  --image-width: calc(var(--image-height) * (3 / 4));
  width: 100%;
  position: relative;
  display: flex;
  justify-content: center;
  align-items: start;
  overflow: hidden;
  height: var(--image-height);
  width: var(--image-width);
  border-radius: ${props => props.theme.borderRadiusMd};

  img {
    position: absolute;
    height: var(--image-height);
    width: auto;
    max-width: var(--image-width);
    object-fit: cover;
    border-radius: ${props => props.theme.borderRadiusMd};
    cursor: pointer;
  }

  @media only screen and (min-width: ${props => props.theme.breakpoints.width.xs}) {
    --image-height: 42rem;
  }

  @media only screen and (min-width: ${props => props.theme.breakpoints.width.lg}) {
    --image-height: 36rem;
    --image-width: calc(var(--image-height) * (9 / 16));
  }

  @media only screen and (min-width: ${props => props.theme.breakpoints.width.xl}) {
    --image-height: 46rem;
  }
`;

export const ControlsContainer = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;
  height: var(--image-height);
  padding: 0 ${props => props.theme.spaceMd};
`;

export const ControlButton = styled.button`
  height: ${props => props.theme.sizeH3};
  width: ${props => props.theme.sizeH3};
  min-height: ${props => props.theme.sizeH3};
  min-width: ${props => props.theme.sizeH3};

  display: inline-flex;
  align-items: center;
  justify-content: center;
  align-self: center;

  color: ${props => props.theme.brand};

  background: transparent;

  border: 2px solid ${props => props.theme.brand};
  border-radius: ${props => props.theme.borderFull};

  z-index: 3;

  &:hover {
    color: ${props => props.theme.backgroundColor};
    background-color: ${props => props.theme.brand};
  }

  &:active {
    scale: 0.9;
    box-shadow: 0 0 0 4px ${props => props.theme.brand + props.theme.clear50};
  }

  svg {
    height: ${props => props.theme.sizeBody};
    width: ${props => props.theme.sizeBody};
    min-height: ${props => props.theme.sizeBody};
    min-width: ${props => props.theme.sizeBody};
  }
`;

export const Pagination = styled.div`
  margin: 0 auto;
  display: flex;
  gap: ${props => props.theme.spaceLg};
`;

export const PageMarker = styled.button`
  height: 0.75rem;
  width: 0.75rem;
  padding: 0;

  background-color: ${props => (props.$active ? props.theme.brand : 'transparent')};

  border: 2px solid ${props => props.theme.brand};
  border-radius: ${props => props.theme.borderFull};
`;
